import React from 'react'

export default class DotProgress extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    render() {
        var dotPos = this.props.dotPos;
        var firstPos = "";
        var secondPos = "";
        var thirdPos = "";
        var message = "";
        if (dotPos == 1) {
            firstPos = " done";
            secondPos = "";
            thirdPos = "";
            message = "Awaiting"
        } else if (dotPos == 2) {
            firstPos = " done";
            secondPos = " done";
            thirdPos = "";
            message = 'Processing';
        } else if (dotPos == 3) {
            firstPos = " done";
            secondPos = " done";
            thirdPos = " done";
            message = "Cleared";
        }

        return (
            <div>
                <i title={this.props.date} class={"fa fas fa-circle dot-progress-circle" + firstPos}/>
                <span class={"dot-progress-line" + secondPos}> &#8213; </span>
                <i class={"fa fas fa-circle dot-progress-circle" + secondPos}/>
                <span class={"dot-progress-line" + thirdPos}> &#8213; </span>
                <i class={"fa fas fa-circle dot-progress-circle" + thirdPos}/>
                <br/>
                <span>{message}</span>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// app/core/utilities/DotProgress.jsx